import { render, staticRenderFns } from "./GraficoVendasMensal.vue?vue&type=template&id=647de428"
import script from "./GraficoVendasMensal.vue?vue&type=script&setup=true&lang=js"
export * from "./GraficoVendasMensal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports